import { isEmailAddressValid } from './ValidityUtils'
import { EMPTY_STRING } from '../Constants/Separators'
import { $debug } from './ConsoleUtils'

export class EmailUtils {
    static isValid(email?: string): boolean {
        return isEmailAddressValid(email)
    }

    static getDomain(email: string): string {
        if (!EmailUtils.isValid(email)) return EMPTY_STRING

        const at: number = email.lastIndexOf('@')
        let domain: string = email.slice(at + 1)

        if (domain.endsWith('.')) domain = domain.slice(0, -1)

        return domain.toLowerCase()
    }

    static getDomainLower(email: string): string {
        return EmailUtils.getDomain(email).toLowerCase()
    }

    static areSameDomain(original: string, ...emails: (string | undefined)[]): boolean {
        const domains: string[] = emails
            .map((email: Definable<string>) => EmailUtils.tryGetDomainLower(email))
            .filter((domain: Nullable<string>): domain is string => domain !== null)

        if (domains.length === 0) return false

        const first: string = EmailUtils.getDomainLower(original)
        return domains.every((domain: string): boolean => domain === first)
    }

    private static compilePattern(pattern: string | RegExp, defaultFlags: string = 'i'): RegExp {
        if (pattern instanceof RegExp) return pattern
        return new RegExp(pattern, defaultFlags)
    }

    static isBlacklistedByPattern(pattern?: Definable<string | RegExp>, email?: Definable<string>): boolean {
        if (!email || !EmailUtils.isValid(email)) return false
        if (!pattern) return false

        try {
            const re: RegExp = EmailUtils.compilePattern(pattern)
            return re.test(email)
        } catch (err) {
            $debug(err)
            return false
        }
    }

    static shouldDisplayByBlacklist(pattern?: Definable<string | RegExp>, email?: Definable<string>): boolean {
        if (!email || !EmailUtils.isValid(email)) return true
        if (!pattern) return true

        try {
            const re: RegExp = EmailUtils.compilePattern(pattern)
            const isBlacklisted: boolean = re.test(email)
            return isBlacklisted
        } catch (err) {
            $debug(err)
            return true
        }
    }

    static tryGetDomain(email?: string): string | null {
        return EmailUtils.isValid(email) ? EmailUtils.getDomain(email!) : null
    }

    static tryGetDomainLower(email?: string): string | null {
        return EmailUtils.isValid(email) ? EmailUtils.getDomainLower(email!) : null
    }
}
